<template>
	<div>
		<h2>{{ $t("horse.menu_contacts") }}</h2>
		<Contact :horse_id="horse.horse_id" />
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'

	export default {
		name: "TiersContact",
		props: ['horse'],
		mounted() {
			this.init_component()
		},
		methods: {
			async init_component() {
			}
		},
		components: {
			Contact : () => import('@/components/Contact/Contact')
		}
	}
</script>
